import React from 'react';
import Modal from '../../../Modal';
import enhance from './enhance';
import styles from './styles.module.scss';

const Warning = ({
  isOpen,
  handleClose,
  clearFiltersButton,
  cancelButton,
  warningTitle,
  warningMessage,
  secondaryAction,
  primaryAction,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      primaryBtnText={cancelButton}
      secondaryBtnText={clearFiltersButton}
      modalStyle={{ maxWidth: '60%' }}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
    >
      <div className={styles.title}>{warningTitle}</div>
      <div className={styles.message}>{warningMessage}</div>
    </Modal>
  );
};

export default enhance(Warning);
